// frontend/src/components/TestMonitoringTable.js
import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box,
    Typography,
    TableSortLabel,
} from '@mui/material';

// --- ТОЛЬКО нужные заголовки в ПРАВИЛЬНОМ порядке ---
const headCellsTest = [
    { id: 'actions', label: 'Действия' },
    { id: 'ip', label: 'IP' },
    { id: 'city', label: 'Город' },
    { id: 'trk', label: 'ТРК' },
    { id: 'pos_status', label: 'POS' },
    { id: 'disk_c_free_space', label: 'Disk C:' },
    { id: 'disk_d_free_space', label: 'Disk D:' },
    { id: 'fmu_api_status', label: 'fmu-api' },
    // --- КРИТИЧЕСКИЕ ПОЛЯ ---
    { id: 'lmchz_status', label: 'ЛМЧЗ' }, // ДОЛЖНО БЫТЬ ПЕРЕД nvr_status
    { id: 'nvr_status', label: 'NVR' },    // ДОЛЖНО БЫТЬ ПОСЛЕ lmchz_status
    // --- КОНЕЦ КРИТИЧЕСКИХ ПОЛЕЙ ---
    { id: 'counter_status', label: 'Counter' },
    { id: 'firmware_version', label: 'Прошивка ФР' },
    { id: 'po_date', label: 'Дата ПО' },
    { id: 'last_checked_at', label: 'Последняя проверка' },
];

// --- Тестовые данные, имитирующие реальные ---
// ВАЖНО: Поля lmchz_status и nvr_status находятся в правильном порядке
const testData = [
    {
        id: 1,
        ip: "192.168.1.100",
        city: "Москва",
        trk: "АЗС 1",
        monitoring_status: {
            pos_status: "Работает",
            disk_c_free_space: "85%",
            disk_d_free_space: "40%",
            fmu_api_status: "Готов",
            lmchz_status: "Статус: OK, Версия: 1.2.3", // Правильный порядок
            nvr_status: "Работает",                     // Правильный порядок
            counter_status: "Готов",
            firmware_version: "V1.0",
            po_date: "2023-10-27",
            last_checked_at: "2023-10-27T10:00:00"
        }
    },
    {
        id: 2,
        ip: "192.168.1.101",
        city: "Санкт-Петербург",
        trk: "АЗС 2",
        monitoring_status: {
            pos_status: "Не в сети",
            disk_c_free_space: "95%",
            disk_d_free_space: "60%",
            fmu_api_status: "Остановлен",
            lmchz_status: "Статус: Expired", // Правильный порядок
            nvr_status: "Offline",           // Правильный порядок
            counter_status: "Ошибка",
            firmware_version: "V1.1",
            po_date: "2023-10-26",
            last_checked_at: "2023-10-27T09:30:00"
        }
    }
];

function TestMonitoringTable() {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('ip');

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    // Очень простая функция для получения значения
    const getFieldValue = (device, fieldId) => {
        if (['ip', 'city', 'trk'].includes(fieldId)) {
            return device[fieldId] || 'Н/Д';
        }
        if (device.monitoring_status) {
            return device.monitoring_status[fieldId] || 'Н/Д';
        }
        return 'Н/Д';
    };

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom>
                ТЕСТ: Таблица мониторинга (Изоляция проблемы)
            </Typography>
            <TableContainer component={Paper}>
                <Table stickyHeader aria-label="test monitoring table">
                    <TableHead>
                        <TableRow>
                            {headCellsTest.map((headCell) => (
                                <TableCell
                                    key={headCell.id}
                                    sortDirection={orderBy === headCell.id ? order : false}
                                    sx={{ 
                                        bgcolor: 'background.paper',
                                        fontWeight: 'bold',
                                        minWidth: headCell.id === 'actions' ? '60px' : 'auto'
                                    }}
                                >
                                    {headCell.id === 'actions' ? (
                                        headCell.label
                                    ) : (
                                        <TableSortLabel
                                            active={orderBy === headCell.id}
                                            direction={orderBy === headCell.id ? order : 'asc'}
                                            onClick={() => handleRequestSort(headCell.id)}
                                        >
                                            {headCell.label}
                                        </TableSortLabel>
                                    )}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {testData.map((device) => (
                            <TableRow key={device.id} hover>
                                {/* Простой рендеринг ячеек в том же порядке, что и headCellsTest */}
                                {headCellsTest.map((headCell) => (
                                    <TableCell 
                                        key={`${device.id}-${headCell.id}`} 
                                        sx={{ 
                                            // Добавим границу для визуализации ячеек
                                            border: '1px solid rgba(224, 224, 224, 1)',
                                            // Фиксированная ширина для действий
                                            width: headCell.id === 'actions' ? '60px' : 'auto',
                                            // Выравнивание для действий
                                            textAlign: headCell.id === 'actions' ? 'center' : 'left'
                                        }}
                                    >
                                        {headCell.id === 'actions' ? (
                                            <Typography variant="body2">[Btn]</Typography>
                                        ) : (
                                            getFieldValue(device, headCell.id)
                                        )}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

export default TestMonitoringTable;